if (!customElements.get('localization-switcher')) {
    class LocalizationSwitcher extends DetailsDisclosure {
        constructor() {
            super();
            this.appendListeners();

            // debug
            //this.querySelector('.disclosure').setAttribute('open', '');
        }

        appendListeners() {
            [...this.querySelectorAll('.disclosure__item a')].forEach(link => {

                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    link.closest('form').querySelector('input[name="country_code"], input[name="locale_code"]').value = link.dataset.value;
                    if (!link.dataset.lang) {
                        link.closest('form').querySelector('input[name="locale_code"]').value = link.dataset.value
                    }
                    link.closest('form')?.submit();
                });
            });
        }
    }

    customElements.define('localization-switcher', LocalizationSwitcher);
}